import { Component } from "react";
import React from "react";
import "./TermsAndConditions.css";
import {
  Typography,
  Container,
} from "@mui/material";

import Navbar from "../../Home/Components/Nav";
import Footer from "../../Home/Components/Footer";

class TermsAndConditions extends Component {
  render() {
    return (
      <div id="terms-container">
        <Navbar />

        {/* Banner */}
        <div id="terms-banner">
          <div id="terms-overlay">
            <Typography
              variant="h3"
              sx={{
                fontWeight: "bold",
                color: "white",
                textAlign: "center",
                fontSize: { xs: "28px", sm: "45px", md: "60px" },
                fontFamily:
                  "Gill Sans, Gill Sans MT, Calibri, sans-serif",
              }}
            >
              TERMS & CONDITIONS
            </Typography>
          </div>
        </div>

        {/* Content */}
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#D12230",
              mb: 3,
              textAlign: "center",
            }}
          >
            Terms & Conditions - MG Central
          </Typography>

          <Typography sx={textStyle}>
            Welcome to MG Central. By accessing and using our website
            https://www.mgcentral.in/, you agree to comply with and be
            bound by the following Terms & Conditions. Please read them
            carefully before using our website or services.
          </Typography>

          <SectionTitle title="1. General Information" />

          <Typography sx={textStyle}>
            MG Central is an authorized MG dealership engaged in
            providing information related to MG vehicles, test drives,
            service support, offers, and customer assistance through
            its website and dealership network.
          </Typography>

          <Typography sx={textStyle}>
            The content provided on this website is for general
            informational purposes only and may be updated or modified
            without prior notice.
          </Typography>

          <SectionTitle title="2. Website Usage" />

          <Typography sx={textStyle}>
            By using this website, you agree:
          </Typography>

          <ul style={listStyle}>
            <li>To use the website only for lawful purposes</li>
            <li>
              Not to misuse or attempt unauthorized access to the
              website
            </li>
            <li>
              Not to copy, reproduce, or distribute website content
              without permission
            </li>
            <li>
              Not to submit false or misleading information through
              forms
            </li>
          </ul>

          <Typography sx={textStyle}>
            MG Central reserves the right to restrict or terminate
            access to users violating these terms.
          </Typography>

          <SectionTitle title="3. Vehicle Information & Pricing" />

          <Typography sx={textStyle}>
            Vehicle specifications, pricing, features, colors, offers,
            and availability displayed on the website are subject to
            change without prior notice.
          </Typography>

          <Typography sx={textStyle}>
            Actual vehicle details may vary depending on model
            availability, dealership stock, location, and manufacturer
            updates.
          </Typography>

          <Typography sx={textStyle}>
            MG Central does not guarantee that all information on the
            website is always accurate, complete, or current.
          </Typography>

          <SectionTitle title="4. Test Drive & Service Requests" />

          <Typography sx={textStyle}>
            Users submitting test drive, service, or inquiry forms
            agree that:
          </Typography>

          <ul style={listStyle}>
            <li>
              The information submitted is accurate and genuine
            </li>
            <li>
              MG Central may contact them via Call, SMS, WhatsApp, or
              Email
            </li>
            <li>
              Appointment timing and vehicle availability may vary
              depending on dealership operations
            </li>
          </ul>

          <Typography sx={textStyle}>
            Submission of a form does not guarantee booking
            confirmation.
          </Typography>

          <SectionTitle title="5. Intellectual Property" />

          <Typography sx={textStyle}>
            All website content including logos, images, graphics,
            text, videos, and branding materials are the property of
            MG Central or their respective owners and are protected
            under applicable intellectual property laws.
          </Typography>

          <Typography sx={textStyle}>
            Unauthorized use, reproduction, or distribution is
            strictly prohibited.
          </Typography>

          <SectionTitle title="6. Third-Party Links" />

          <Typography sx={textStyle}>
            This website may contain links to third-party websites for
            user convenience.
          </Typography>

          <Typography sx={textStyle}>
            MG Central is not responsible for the content, privacy
            practices, or reliability of any external websites.
          </Typography>

          <SectionTitle title="7. Limitation of Liability" />

          <Typography sx={textStyle}>
            MG Central shall not be held liable for:
          </Typography>

          <ul style={listStyle}>
            <li>
              Any direct or indirect damages arising from website usage
            </li>
            <li>Temporary website unavailability</li>
            <li>Errors or omissions in website content</li>
            <li>
              Delays or interruptions caused by technical issues
            </li>
          </ul>

          <Typography sx={textStyle}>
            Users access and use the website at their own discretion
            and risk.
          </Typography>

          <SectionTitle title="8. Privacy & Data Usage" />

          <Typography sx={textStyle}>
            By using this website and submitting your information, you
            agree to the collection and usage of your data in
            accordance with our Privacy Policy.
          </Typography>

          <SectionTitle title="9. Changes to Terms & Conditions" />

          <Typography sx={textStyle}>
            MG Central reserves the right to update or modify these
            Terms & Conditions at any time without prior notice.
          </Typography>

          <Typography sx={textStyle}>
            Continued use of the website after modifications
            constitutes acceptance of the revised terms.
          </Typography>

          <SectionTitle title="10. Contact Information" />

          <Typography sx={textStyle}>
            MG Central
          </Typography>

          <Typography sx={textStyle}>
            Website: https://www.mgcentral.in/
          </Typography>

          <Typography sx={textStyle}>
            Email: bhubaneshwarcentral.marketing1@mgdealer.co.in
          </Typography>

          <Typography sx={textStyle}>
            Phone: +91 8599005857
          </Typography>

          <Typography
            sx={{
              ...textStyle,
              fontWeight: "bold",
              mt: 4,
            }}
          >
            Last Updated: May 2026
          </Typography>
        </Container>

        <Footer />
      </div>
    );
  }
}

const SectionTitle = ({ title }) => (
  <Typography
    variant="h5"
    sx={{
      fontWeight: "bold",
      color: "#D12230",
      mt: 5,
      mb: 2,
      fontFamily: "Gill Sans, Gill Sans MT, Calibri, sans-serif",
    }}
  >
    {title}
  </Typography>
);

const textStyle = {
  fontSize: {
    xs: "14px",
    sm: "15px",
    md: "16px",
  },
  lineHeight: "30px",
  color: "#333",
  fontFamily: "LatoGoogle,Lato,LatoWeb,sans-serif",
  mb: 2,
};

const listStyle = {
  paddingLeft: "20px",
  lineHeight: "35px",
  color: "#333",
  fontFamily: "LatoGoogle,Lato,LatoWeb,sans-serif",
};

export default TermsAndConditions;